module.exports = __webpack_public_path__ + "static/media/om_eyebrowshape_hardangled_vector.bfc1e5ff.svg";